module.exports = __webpack_public_path__ + "static/34import-09b160962850acd5293291f3806e4f48.png";